
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Carlos Mendoza',
      location: 'Ciudad de México',
      rating: 5,
      text: 'Excelente servicio! Rentamos el yate de lujo para celebrar nuestro aniversario y fue una experiencia inolvidable. El capitán muy profesional y atento. Totalmente recomendado.',
      date: 'Hace 2 semanas'
    },
    {
      name: 'Ana García',
      location: 'Puebla',
      rating: 5,
      text: 'La lancha familiar fue perfecta para nuestro paseo. Los niños se divirtieron mucho y nosotros pudimos relajarnos. Todo muy limpio y bien organizado. Volveremos sin duda.',
      date: 'Hace 1 mes'
    },
    {
      name: 'Roberto Sánchez',
      location: 'Veracruz',
      rating: 5,
      text: 'El tour de pesca deportiva superó nuestras expectativas. Pescamos varios peces grandes y el guía conocía perfectamente las zonas. Equipo de primera calidad.',
      date: 'Hace 3 semanas'
    },
    {
      name: 'María Fernández',
      location: 'Guadalajara',
      rating: 5,
      text: 'Organizamos la despedida de soltera de mi hermana en el catamarán y fue espectacular. La atención al detalle, la música, todo perfecto. Las chicas quedaron encantadas.',
      date: 'Hace 1 semana'
    },
    {
      name: 'Luis Torres',
      location: 'Monterrey',
      rating: 5,
      text: 'El atardecer romántico fue mágico. Mi esposa quedó fascinada con la experiencia. El champagne, la música, las vistas... todo estuvo increíble. Muy recomendable para parejas.',
      date: 'Hace 2 meses'
    },
    {
      name: 'Patricia Ruiz',
      location: 'Querétaro',
      rating: 5,
      text: 'Contraté la lancha deportiva para un día con amigos y fue genial. Velocidad, emoción y mucha diversión. El capitán nos llevó a lugares hermosos. Precio justo por el servicio.',
      date: 'Hace 3 semanas'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Testimonios reales de personas que han disfrutado nuestros servicios
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div>
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </div>
                <p className="text-xs text-gray-400">{testimonial.date}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center bg-teal-50 px-6 py-3 rounded-full">
            <i className="ri-star-fill text-teal-500 text-xl mr-2"></i>
            <span className="text-gray-900 font-semibold">4.9/5 basado en 127 reseñas</span>
          </div>
        </div>
      </div>
    </section>
  );
}
